exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a {\n  color: #9c27b0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/client/components/serviceObject/tree-node/serviceObject-tree-node.component.scss
// module id = ../../../../../src/app/client/components/serviceObject/tree-node/serviceObject-tree-node.component.scss
// module chunks = 0